import _ from 'lodash';
import * as actions from 'app/actions/marketing';

export default function(state = {}, action) {
  switch (action.type) {
    case actions.SET_MARKETING_PAGE: {
      return Object.assign({}, state, {
        marketingPage: _.get(action, 'result.fields'),
      });
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./app/reducers/marketing.js